import { DocumentStatus } from '@nemuru-eng/js-api-client';

export enum DocumentStatusWithSent {
  PENDING = DocumentStatus.PENDING,
  UPLOADED = DocumentStatus.UPLOADED,
  INCIDENCE = DocumentStatus.INCIDENCE,
  VALIDATED = DocumentStatus.VALIDATED,
  SENT = 'sent',
}
